import FormularioListaResposta from './FormularioListaResposta';

export default FormularioListaResposta;